/**
 * Screen manager: start (name + play), death (score + replay/menu), and the
 * skins screen toggle. Pure DOM/UI — it knows nothing about the simulation; the
 * orchestrator wires its callbacks to game actions.
 */
import { el, hide, show } from './dom';

export interface ScreenCallbacks {
  onPlay: (name: string) => void;
  onReplay: () => void;
  onMenu: () => void;
  onOpenSkins: () => void;
  onCloseSkins: () => void;
}

export class Screens {
  private readonly startScreen = el('start-screen');
  private readonly deathScreen = el('death-screen');
  private readonly skinsScreen = el('skins-screen');
  private readonly nameInput = el<HTMLInputElement>('name-input');
  private readonly form = el<HTMLFormElement>('start-form');
  private readonly skinsBtn = el<HTMLButtonElement>('skins-btn');
  private readonly deathScore = el('death-score');
  private readonly deathBest = el('death-best');

  constructor(cb: ScreenCallbacks, opts: { skinsEnabled: boolean; lastName: string }) {
    this.nameInput.value = opts.lastName;

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      cb.onPlay(this.name());
    });
    el('replay-btn').addEventListener('click', () => cb.onReplay());
    el('menu-btn').addEventListener('click', () => cb.onMenu());
    el('skins-close-btn').addEventListener('click', () => cb.onCloseSkins());

    if (opts.skinsEnabled) {
      show(this.skinsBtn);
      this.skinsBtn.addEventListener('click', () => cb.onOpenSkins());
    }
  }

  name(): string {
    const v = this.nameInput.value.trim();
    return v || 'Player';
  }

  showStart(): void {
    hide(this.deathScreen);
    hide(this.skinsScreen);
    show(this.startScreen);
    this.nameInput.focus();
  }

  showDeath(score: number, best: number): void {
    this.deathScore.textContent = String(score);
    this.deathBest.textContent = String(best);
    hide(this.startScreen);
    show(this.deathScreen);
  }

  showSkins(): void {
    show(this.skinsScreen);
  }

  hideSkins(): void {
    hide(this.skinsScreen);
  }

  hideAll(): void {
    hide(this.startScreen);
    hide(this.deathScreen);
    hide(this.skinsScreen);
  }
}
